"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration"));

var _uiKit = require("@devsta/ui-kit");

var _clientAuth = require("@devsta/client-auth");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

require("../styles/_reporting.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INITIAL_FORM_VALUES = {
  organisationOption: {
    value: void 0,
    label: 'Select organisation...'
  },
  startDate: void 0,
  endDate: void 0
};

var Reporting = /*#__PURE__*/function (_Component) {
  _inherits(Reporting, _Component);

  function Reporting() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Reporting);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Reporting)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, INITIAL_FORM_VALUES, {
      organisationOptions: []
    }));

    _defineProperty(_assertThisInitialized(_this), "setDate", (0, _lodash.default)(function (type) {
      return function (date) {
        _this.setState(_defineProperty({}, type, date));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getOrganisations, _ref2, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getOrganisations = _this.props.getOrganisations;
              _context.next = 3;
              return getOrganisations();

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(!data || !data.getOrganisations || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _this.setState({
                organisationOptions: data.getOrganisations.map(function (_ref3) {
                  var organisationId = _ref3.organisationId,
                      name = _ref3.name;
                  return {
                    value: organisationId,
                    label: name
                  };
                })
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleOrgSelect", function (option) {
      _this.setState({
        organisationOption: option
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState(INITIAL_FORM_VALUES);
    });

    _defineProperty(_assertThisInitialized(_this), "downloadReport", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var serviceEndpoint, _this$state, startDate, endDate, organisationOption, _organisationOption$v, organisationId, _credentials$get, token, queryStartDate, queryEndDate, aTag;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              serviceEndpoint = _reactGlobalConfiguration.default.get('serviceEndpoint');
              _this$state = _this.state, startDate = _this$state.startDate, endDate = _this$state.endDate, organisationOption = _this$state.organisationOption;
              _organisationOption$v = organisationOption.value, organisationId = _organisationOption$v === void 0 ? '' : _organisationOption$v;
              _credentials$get = _clientAuth.credentials.get(), token = _credentials$get.token;
              queryStartDate = startDate ? encodeURIComponent(startDate.format()) : '';
              queryEndDate = endDate ? encodeURIComponent(endDate.format()) : '';
              aTag = document.createElement('a');
              aTag.setAttribute('style', 'display:none');
              aTag.setAttribute('href', "".concat(serviceEndpoint, "export/reports/invoice?organisationId=").concat(organisationId, "&t=").concat(token, "&startDate=").concat(queryStartDate, "&endDate=").concat(queryEndDate));
              aTag.click();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    return _this;
  }

  _createClass(Reporting, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.fetchData();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          organisationOptions = _this$state2.organisationOptions,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate,
          organisationOption = _this$state2.organisationOption;
      return _react.default.createElement("div", {
        className: "org-reports page"
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: "Manage Reports",
        subtitle: "Shootsta",
        actionBtnText: "Reset",
        actionBtnOnClick: this.reset
      }), _react.default.createElement("div", {
        className: "org-reports__content"
      }, _react.default.createElement("div", null, _react.default.createElement(_uiKit.Dropdown, {
        id: "organisation-report-org",
        label: "Organisation",
        value: organisationOption,
        options: organisationOptions,
        onChange: this.handleOrgSelect
      })), _react.default.createElement(_uiKit.DatePicker, {
        id: "organisation-report-dates",
        startLabel: "From Date",
        endLabel: "To Date",
        onSelectStartDate: this.setDate('startDate'),
        onSelectEndDate: this.setDate('endDate'),
        startDate: startDate,
        endDate: endDate,
        enableTime: true,
        enablePastDays: true,
        displayDateFormat: "YYYY-MM-DD HH:mm A"
      }), _react.default.createElement(_uiKit.Button, {
        className: "org-reports__save-btn",
        onClick: this.downloadReport
      }, "Generate Report")));
    }
  }]);

  return Reporting;
}(_react.Component);

exports.default = Reporting;